import { FC } from 'react';
import SchoolList from './SchoolList';
import UseSchoolList from './UseSchoolList';

const SchoolListContainer: FC = () => {
  return <SchoolList {...UseSchoolList()} />;
};

export default SchoolListContainer;
